import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'
import {Routes} from '@/src/config/routes'
import {IBasketRepository} from '@/src/core/domain/repositories'
import {BasketData, NewBasketItem, SyncBasketItem} from '@/src/entities/basket/types'
import type {IApiClientService} from '@/src/ports/services/api'

/**
 * API-based implementation of IBasketRepository
 *
 * Handles all basket-related API calls.
 * Implements the Repository pattern - provides a collection-like interface
 * while abstracting the actual data persistence mechanism (REST API).
 */
@injectable()
export class ApiBasketRepository implements IBasketRepository {
  @inject(DI.IApiClientService)
  apiClient!: IApiClientService

  async add(item: NewBasketItem): Promise<BasketData> {
    return this.apiClient.post<BasketData>(Routes.webApi.basket.add, {
      data: item,
    })
  }

  async sync(items: SyncBasketItem[]): Promise<BasketData> {
    return this.apiClient.post<BasketData>(Routes.webApi.basket.sync, {
      data: {items},
    })
  }

  async delete(itemId: string): Promise<BasketData> {
    return this.apiClient.post<BasketData>(Routes.webApi.basket.delete, {
      data: {
        id: itemId,
      },
    })
  }
}
